import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  BlogCategoriaRef,
  BlogTagRef,
  NoticiaApi,
  NoticiaShowResponse,
  Paginated,
} from './catalog-api.model';

export type FiltrosNoticias = {
  page?: number;
  per_page?: number;
  q?: string;
  categoria_id?: number;
  categoria?: string;
  tag?: string;
  sort?: 'recent' | 'oldest' | 'title';
};

@Injectable({ providedIn: 'root' })
export class NoticiasService {
  private readonly base = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  list(f?: FiltrosNoticias): Observable<Paginated<NoticiaApi>> {
    let params = new HttpParams();
    if (f?.page) {
      params = params.set('page', String(f.page));
    }
    if (f?.per_page) {
      params = params.set('per_page', String(f.per_page));
    }
    if (f?.q?.trim()) {
      params = params.set('q', f.q.trim());
    }
    if (f?.categoria_id) {
      params = params.set('categoria_id', String(f.categoria_id));
    }
    if (f?.categoria) {
      params = params.set('categoria', f.categoria);
    }
    if (f?.tag) {
      params = params.set('tag', f.tag);
    }
    if (f?.sort) {
      params = params.set('sort', f.sort);
    }
    return this.http.get<Paginated<NoticiaApi>>(`${this.base}/noticias`, { params });
  }

  show(slugOrId: string | number): Observable<NoticiaShowResponse> {
    return this.http.get<NoticiaShowResponse>(`${this.base}/noticias/${slugOrId}`);
  }

  categorias(): Observable<BlogCategoriaRef[]> {
    return this.http
      .get<BlogCategoriaRef[] | { data: BlogCategoriaRef[] }>(`${this.base}/noticias/categorias`)
      .pipe(map((r) => (Array.isArray(r) ? r : r.data ?? [])));
  }

  tags(): Observable<BlogTagRef[]> {
    return this.http
      .get<BlogTagRef[] | { data: BlogTagRef[] }>(`${this.base}/noticias/tags`)
      .pipe(map((r) => (Array.isArray(r) ? r : r.data ?? [])));
  }
}
